import type { TUtils } from "@monta/utils";
import styles from "./actions.module.scss";
import AfterLogin from "./afterLogin/AfterLogin";
import BeforLogin from "./beforLogin/BeforLogin";

export interface ActionsProps {
  auth: TUtils["auth"];
  cart: TUtils["cart"];
}

const Actions = (props: ActionsProps) => {
  const { auth, cart } = props;
  const loginInfo = auth.useAuth();

  return (
    <div className={styles["actions"]}>
      {loginInfo?.id ? (
        <AfterLogin loginInfo={loginInfo} cart={cart} auth={auth} />
      ) : (
        <BeforLogin cart={cart} />
      )}
    </div>
  );
};

export default Actions;
